import { createContext, type Dispatch, type SetStateAction, useContext } from "react";
import type { Recommendation } from "../../utils/models";

type RecommendationsContextType = {
	recommendations: Recommendation[];
	setRecommendations: Dispatch<SetStateAction<Recommendation[]>>;
	isLoading: boolean;
	error: Error | null;
};

export const RecommendationsContext = createContext<RecommendationsContextType | null>(null);

export const useRecommendationsContext = () => {
	const context = useContext(RecommendationsContext);

	if (!context) {
		throw new Error("useRecommendationsContext must be used within a RecommendationsProvider");
	}
	return context;
};
